import { jsx as C } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9069 1C8.76348 1 6.21528 3.54821 6.21528 6.69158C6.21528 9.0664 7.66975 11.1015 9.73649 11.9547C9.73636 11.9547 9.73623 11.9548 9.73609 11.9548C10.4051 12.2311 11.1382 12.3835 11.907 12.3835C12.6757 12.3835 13.4089 12.231 14.0779 11.9548C14.0778 11.9547 14.0776 11.9547 14.0774 11.9546C16.1441 11.1014 17.5984 9.06633 17.5984 6.69158C17.5984 3.54821 15.0502 1 11.9069 1ZM3.11365 20.4782C3.11365 17.3027 4.79688 14.5204 7.31979 12.9747C8.60587 13.9153 10.1916 14.4705 11.907 14.4705C13.6224 14.4705 15.2082 13.9152 16.4943 12.9746C19.0173 14.5202 20.7006 17.3027 20.7006 20.4782V21H3.11365V20.4782Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
